<template>
  <div class="login-container">
    <div class="login-shell">
      <section class="login-hero">
        <!--span class="hero-tag">Blue Refresh</span-->
        <h1 class="login-title">{{ $tText('login.page.title', '闸口通管理系统') }}</h1>
        <!--p class="login-subtitle">统一适配手机 H5 与桌面浏览器的蓝色控制台体验，让登录、识别与通行控制更清晰。</p-->

        <!--div class="hero-card">
          <div class="hero-card__item">
            <span class="hero-card__label">视觉方向</span>
            <strong>蓝色安全感</strong>
          </div>
          <div class="hero-card__item">
            <span class="hero-card__label">设备状态</span>
            <strong>实时在线监控</strong>
          </div>
          <div class="hero-card__item">
            <span class="hero-card__label">适配能力</span>
            <strong>手机与桌面双态布局</strong>
          </div>
        </div-->
      </section>

      <section class="login-panel">
        <div class="panel-header">
          <h2>欢迎登录</h2>
          <!--p>{{ $tText('login.page.subtitle', '请输入账号信息，进入闸口通行管理中心') }}</p-->
        </div>

        <div class="login-form">
          <van-form @submit="onSubmit">
            <van-field
              v-model="form.username"
              name="username"
              :label="$tText('login.form.usernameLabel', '用户名')"
              :placeholder="$tText('login.form.usernamePlaceholder', '请输入用户名')"
              :rules="[{ required: true, message: $tText('login.form.usernamePlaceholder', '请输入用户名') }]"
              left-icon="contact"
            />

            <van-field
              v-model="form.password"
              :type="showPassword ? 'text' : 'password'"
              name="password"
              :label="$tText('login.form.passwordLabel', '密码')"
              :placeholder="$tText('login.form.passwordPlaceholder', '请输入密码')"
              :rules="[{ required: true, message: $tText('login.form.passwordPlaceholder', '请输入密码') }]"
              left-icon="lock"
              :right-icon="showPassword ? 'eye-o' : 'closed-eye'"
              @click-right-icon="showPassword = !showPassword"
            />

            <div class="captcha-container">
              <van-field
                v-model="form.captcha"
                name="captcha"
                type="digit"
                maxlength="4"
                :label="$tText('login.form.captchaLabel', '验证码')"
                :placeholder="$tText('login.form.captchaPlaceholder', '请输入验证码')"
                :rules="[{ required: true, message: $tText('login.form.captchaPlaceholder', '请输入验证码') }]"
                left-icon="shield-o"
              />
              <div class="captcha-image" @click="refreshCaptcha">
                <identify :identify-code="captchaText" />
              </div>
            </div>

            <div class="remember-row">
              <van-checkbox v-model="rememberPassword">记住密码</van-checkbox>
              <span class="remember-tip">建议仅在可信设备上启用</span>
            </div>

            <div class="login-button-container">
              <van-button
                round
                block
                type="primary"
                native-type="submit"
                :loading="loading"
                loading-text="登录中..."
                class="login-button"
              >
                {{ $tText('login.button.submit', '登录系统') }}
              </van-button>
            </div>
          </van-form>
        </div>

        <div class="login-footer">
          <span class="version-info">V{{ version }}</span>
        
        </div>
      </section>
    </div>

    <van-popup v-model="showChangePassword" position="center" :style="{ width: '90%', maxWidth: '400px', borderRadius: '16px', boxShadow: '0 8px 32px rgba(0,0,0,0.18)', padding: '0' }" round>
      <div class="change-password-popup">
        <div class="popup-header">
          <h3 class="popup-title">修改初始密码</h3>
        </div>
        <van-form @submit="onChangePasswordSubmit" class="password-form">
          <van-field
            v-model="changePasswordForm.newPassword"
            type="password"
            name="newPassword"
            label="新密码"
            placeholder="请输入新密码"
            :rules="[{ required: true, message: '请输入新密码' }]"
            class="popup-field"
          />
          <van-field
            v-model="changePasswordForm.confirmPassword"
            type="password"
            name="confirmPassword"
            label="确认新密码"
            placeholder="请再次输入新密码"
            :rules="[{ required: true, message: '请再次输入新密码' }]"
            class="popup-field"
          />
          <div class="form-actions">
            <van-button
              round
              block
              type="primary"
              native-type="submit"
              :loading="changePasswordLoading"
              class="popup-btn"
            >
              确认修改
            </van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Identify from '@/components/identify.vue'
import axios from '@/utils/request'
import md5 from 'blueimp-md5'
import { fetchMultiDic, default as globalDic } from '@/utils/dic'
import { loadUiTexts } from '@/utils/uiText'
import version from '@/version.js'
import { getDefaultAuthorizedPath, getPathByPermissionCode } from '@/constants/pagePermissions'

export default {
  name: 'LoginPage',
  components: {
    Identify
  },
  data() {
    return {
      form: {
        username: '',
        password: '',
        captcha: ''
      },
      rememberPassword: false,
      showPassword: false,
      loading: false,
      captchaText: 'A8B9',
      showChangePassword: false,
      changePasswordForm: {
        newPassword: '',
        confirmPassword: ''
      },
      changePasswordLoading: false,
      version: version
    };
  },
  computed: {
    currentUser() {
      return JSON.parse(localStorage.getItem('userInfo') || '{}');
    }
  },
  methods: {
    async onSubmit(values) {
      this.loading = true;
      // 前端先校验验证码
      if (values.captcha !== this.captchaText) {
        this.$toast.fail('验证码错误');
        this.refreshCaptcha();
        this.loading = false;
        return;
      }
      try {
        const passwordMd5 = md5(values.password)
        const res = await axios.post('/api/User/Login', {
          username: values.username,
          password: passwordMd5
        });
        if (res && res.data && res.data.success) {
          this.$toast.success('登录成功');
          const loginData = res.data.data || {};
          const token = loginData.token || res.data.message;
          localStorage.setItem('token', token);
          localStorage.setItem('username', values.username);
          localStorage.setItem('userInfo', JSON.stringify(loginData));
          await loadUiTexts(loginData.portCode || '');
          // 登录成功后拉取所有字典并存入全局对象
          await fetchMultiDic(['D_Role', 'D_Port', 'D_AlarmType']);
          console.log('globalDic',globalDic)
          // 判断是否初始密码
          if (values.password === '111111') {
            // 弹窗强制修改密码
            this.showChangePassword = true;
            this.changePasswordForm = { newPassword: '', confirmPassword: '' };
            // 保存登录信息以便后续调用修改密码
            this._loginUser = { username: values.username, oldPassword: values.password };
            this.loading = false;
            return;
          }
          
          if (this.rememberPassword) {
            localStorage.setItem('rememberLogin', JSON.stringify({
              username: values.username,
              password: values.password
            }));
          } else {
            localStorage.removeItem('rememberLogin');
          }
          const defaultPath =
            getPathByPermissionCode(loginData.defaultPageCode) ||
            getDefaultAuthorizedPath(loginData.permissionCodes);
          this.$router.push(defaultPath);
        } else {
          this.$toast.fail(res.data.message || '用户名或密码错误');
          this.refreshCaptcha();
        }
      } catch (err) {
        this.$toast.fail('登录失败，请检查网络或稍后重试');
        this.refreshCaptcha();
      }
      this.loading = false;
    },
    async onChangePasswordSubmit(values) {
      if (!values.newPassword || !values.confirmPassword) {
        this.$toast.fail('请输入新密码和确认密码');
        return;
      }
      if (values.newPassword !== values.confirmPassword) {
        this.$toast.fail('两次输入的新密码不一致');
        return;
      }
      this.changePasswordLoading = true;
      try {
        // 调用后端接口修改密码
        this.$axios = this.$axios || require('@/utils/request').default;
        this.$axios.post('/api/User/Modify', {
          id: this.currentUser.userId || this.currentUser.id,
          password: md5(values.newPassword),
        }).then(res => {
          if (res && res.data && res.data.success) {
            this.$toast.success('密码修改成功,请重新登录');
            //this.showChangePassword = false;
            this.passwordForm = {
              newPassword: '',
              confirmPassword: ''
            };
            // 清除token等信息
            localStorage.removeItem('token');
            localStorage.removeItem('userInfo');
            this.showChangePassword = false;
            //this.$router.replace('/login');
          } else {
            this.$toast.fail(res.data.message || '密码修改失败');
          }
        }).catch(() => {
          this.$toast.fail('密码修改失败');
        }).finally(() => {
          this.passwordLoading = false;
        });        
      } catch (err) {
        this.$toast.fail('密码修改失败，请稍后重试');
      }
      this.changePasswordLoading = false;
    },
    refreshCaptcha() {
      // 生成随机数字验证码
      let result = '';
      for (let i = 0; i < 4; i++) {
        result += Math.floor(Math.random() * 10);
      }
      this.captchaText = result;
    }
  },
  mounted() {
    this.refreshCaptcha();
    // 自动填充记住的用户名和密码
    const remembered = localStorage.getItem('rememberLogin');
    if (remembered) {
      try {
        const obj = JSON.parse(remembered);
        this.form.username = obj.username || '';
        this.form.password = obj.password || '';
        this.rememberPassword = true;
      } catch (e) {}
    }
  }
};
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.login-container::before,
.login-container::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}

.login-container::before {
  width: 420px;
  height: 420px;
  top: -120px;
  left: -120px;
  background: radial-gradient(circle, rgba(22, 119, 255, 0.28) 0%, rgba(22, 119, 255, 0) 72%);
}

.login-container::after {
  width: 360px;
  height: 360px;
  right: -120px;
  bottom: -120px;
  background: radial-gradient(circle, rgba(15, 79, 185, 0.22) 0%, rgba(15, 79, 185, 0) 72%);
}

.login-shell {
  position: relative;
  z-index: 1;
  width: min(1080px, 100%);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 28px;
  align-items: center;
}

.login-hero {
  color: var(--text-primary);
  padding: 24px 16px;
}

.hero-tag {
  display: inline-flex;
  align-items: center;
  padding: 7px 12px;
  border-radius: 999px;
  background: rgba(22, 119, 255, 0.1);
  color: var(--brand-700);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin-bottom: 18px;
}

.login-title {
  font-size: 44px;
  line-height: 1.08;
  font-weight: 800;
  margin-bottom: 16px;
}

.login-subtitle {
  color: var(--text-secondary);
  font-size: 16px;
  line-height: 1.85;
  max-width: 520px;
}

.hero-card {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-top: 32px;
}

.hero-card__item {
  padding: 18px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.74);
  border: 1px solid rgba(215, 229, 251, 0.9);
  box-shadow: var(--shadow-card);
  backdrop-filter: blur(16px);
}

.hero-card__item strong {
  display: block;
  color: var(--text-primary);
  line-height: 1.55;
}

.hero-card__label {
  display: block;
  margin-bottom: 8px;
  color: var(--text-muted);
  font-size: 12px;
  font-weight: 700;
}

.login-panel {
  border-radius: 30px;
  padding: 28px;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(215, 229, 251, 0.9);
  box-shadow: var(--shadow-soft);
  backdrop-filter: blur(18px);
}

.panel-header {
  margin-bottom: 22px;
}

.panel-header h2 {
  font-size: 28px;
  line-height: 1.2;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.panel-header p {
  color: var(--text-secondary);
  line-height: 1.6;
}

.login-form {
  border-radius: 24px;
  padding: 20px;
  background: linear-gradient(180deg, rgba(248, 251, 255, 0.92) 0%, #ffffff 100%);
  border: 1px solid rgba(223, 234, 252, 0.95);
}

.login-form :deep(.van-field__label) {
  width: 3.2em;
}

.captcha-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.captcha-container .van-field {
  flex: 1;
}

.captcha-image {
  width: 104px;
  height: 52px;
  background: linear-gradient(180deg, #f4f8ff 0%, #e9f2ff 100%);
  border: 1px solid var(--border-soft);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  overflow: hidden;
}

.remember-row {
  margin: 14px 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: var(--text-secondary);
  font-size: 12px;
}

.remember-tip {
  color: var(--text-muted);
}

.login-button-container {
  margin-top: 28px;
}

.login-button {
  height: 52px;
  font-size: 16px;
  font-weight: 700;
}

.login-footer {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
  color: var(--text-muted);
  font-size: 12px;
  margin-top: 18px;
}

.footer-divider {
  width: 1px;
  height: 14px;
  background: var(--border-soft);
}

.change-password-popup {
  padding: 28px 20px 20px 20px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.popup-header {
  text-align: center;
  margin-bottom: 18px;
}
.popup-title {
  font-size: 22px;
  font-weight: 600;
  color: #333;
  margin: 0;
  letter-spacing: 1px;
}
.popup-field {
  margin-bottom: 18px;
}
.popup-btn {
  margin-top: 10px;
  font-size: 16px;
  height: 46px;
}

.version-info {
  color: inherit;
  font-size: inherit;
  position: static;
}

@media (max-width: 960px) {
  .login-shell {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .login-hero {
    padding: 8px 4px;
  }

  .hero-card {
    grid-template-columns: 1fr;
  }

  .login-title {
    font-size: 34px;
  }
}

@media (max-width: 500px) {
  .login-container {
    padding: 14px;
  }

  .login-panel {
    padding: 20px 16px;
    border-radius: 24px;
  }

  .login-form {
    padding: 16px 14px;
  }

  .captcha-container {
    align-items: center;
    flex-direction: row;
  }

  .captcha-image {
    width: 104px;
    flex: 0 0 104px;
  }

  .remember-row {
    align-items: flex-start;
    flex-direction: column;
  }

  .change-password-popup {
    padding: 18px 8px 12px 8px;
  }

  .popup-title {
    font-size: 18px;
  }
}
</style>
